<template>
	<div class="commercialAgent" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="代理商加盟" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="head_image" :style="paddT">
         		<img src="../../assets/advDetail/commercialAgent/main.png" alt="">
			</van-col>
			<van-col span="24" class="benefit">
				<p class="odds">三大核心优势</p>
				<div class="agent">
					<div>
						<span class="circle"></span>
					</div>
					<div class="agent_">成为代理商的好处</div>
				</div>
				<div class="benefit_3">
					<div class="business">
						<div class="business-left">
							<img src="../../assets/advDetail/commercialAgent/income2.png" alt="">
						</div>
						<div class="business-right">
							<p class="title">商家收益</p>
							<p class="enjoy">享受代理区域商家交易流水的0.7%</p>
						</div>
					</div>
					<div class="business">
						<div class="business-left">
							<img src="../../assets/advDetail/commercialAgent/income1.png" alt="">
						</div>
						<div class="business-right">
							<p class="title">会员收益</p>
							<p class="enjoy">
								享受推荐会员个人消费金额的0.2%/0.3%/0.2%红包奖励
							</p>
						</div>
					</div>
					<div class="business">
						<div class="business-left">
							<img src="../../assets/advDetail/commercialAgent/support.png" alt="">
						</div>
						<div class="business-right">
							<p class="title">总部扶持</p>
							<p class="enjoy">
								具有区域独占性，享受严格的区域独家保护政策，确保区域代理运营中心独家经营权。<br>
								获得销巴生活总部培训及技术指导，市场开拓支持。<br>
								销巴生活总部安排专业的市场团队对代理区域进行市场开拓及辅导。
							</p>
						</div>
					</div>
				</div>
			</van-col>
			<van-col span="24" class="xb-main">
				<div class="circle">
					<img src="../../assets/advDetail/commercialAgent/circle.png" alt="">
				</div>
				<div class="circle_1"></div>
				<div class="xb-title">
					<p class="odds xb-p1">六大合作资质</p>
					<p class="xb-p2">如何成为代理商</p>
				</div>
				<div class="xb-items">
					<p>对消费商行业有一定深度的认知</p>
					<p>和销巴生活模式、企业价值观保持一致</p>
					<p>有电子商务跟互联网服务相关的公司</p>
					<p>有市场推广的团队及推广经验</p>
					<p>成立销巴代理服务中心</p>
					<p>组建6人以上的全职推广团队</p>
				</div>
			</van-col>
			<van-col span="24" class="regular">
				<div class="circle">
					<img src="../../assets/advDetail/commercialAgent/oval3.png" alt="">
				</div>
				<div class="circle3"></div>
				<div class="xb-title">
					<p class="odds xb-p1">六大发展规划</p>
					<p class="xb-p3">成为代理商的职责</p>
				</div>
				<div class="regular-items">
					<div class="regular_all">
	
						1.负责所辖区域的团队组建与管理，并带领团队积极开发商家和会员。<br>
						2.负责已开发商家和会员的维护管理，根据销巴盈利模式对商家进行指导，促进商家盈利；对会员进行指导，促进会员持续使用销巴生活APP。<br>
						3.负责执行销巴生活统一的营销政策和广告政策。<br>
						4.负责建立销巴生活和商家、会员之间的沟通桥梁，积极扩大销巴生活的品牌知名度和市场占有率。
						
					</div>
				</div>
			</van-col>
			<van-col span="24" class="cooperation">
				<div class="box">
					<h1>关于合作企业</h1>
					<div class="introduction">
						<div class="introduction-title">
							<img src="../../assets/advDetail/commercialAgent/company.png" alt="">
							<span>公司简介</span>
						</div>
						<div class="content_1">
							浙江销巴科技有限公司(以下简称"销巴生活")(ZhejiangShallBuyTechnologyCo.,Ltd.)，成立于2013年12月18日，是一家集人才孵化、电商服务、网络技术等于一体的互联网科技公司。销巴立足于电子商务领域，专注打造新型消费模式，以国家政策为导向，高举“分享经济”旗帜，促进“消费者”逐步转变为“消费商”。
						</div>
					</div>
					<div class="introduction">
						<div class="introduction-title">
							<img class="culture_1" src="../../assets/advDetail/commercialAgent/culture1.png" alt="">
							<span>
								企业文化
							</span>
						</div>
						<div class="content_1">
							1. 企业愿景<br>
							致力于推进消费行业发展，铸就百年辉煌。<br>
							2. 企业定位<br>
							专业专注的消费经济服务商。<br>
							3. 企业使命<br>
							专业塑造品牌，服务创造价值。<br>
							4. 企业核心价值观<br>
							助力消费革命，推动消费养老。
						</div>
					</div>
					<div class="circle-right">
						<img src="../../assets/advDetail/commercialAgent/oval1.png" alt="">
					</div>
					<div class="introduction">
						<div class="introduction-title">
							<img class="culture_2" src="../../assets/advDetail/commercialAgent/culture.png" alt="">
							<span>
								核心文化
							</span>
						</div>
						<div class="content_1">
							<div class="circle-r"></div>
							销巴生活始终立足刚需消费，以电子商务为依托，以积分体系作支撑，以用户囗碑为传播渠道，以全新消费模式引领消费潮流，坚持做中国消费市场的守护者。
						</div>
						<div class="xb-top">
							刚需消费，养老无忧
						</div>
						<div class="xb-center">刚需消费是消费增值服务的基石，没有刚需消费的支持就不存在消费增值模式。作为“消费养老”领域知名的公共服务平台，销巴生活存在的最重要的创新意义在于：它开辟了养老金的新渠道，找到了养老金的新源头——用现在的刚需消费，为未来的生活提供保障。
						</div>
						<div class="xb-top">
							日益丰富的消费场景
						</div>
						<div class="xb-center">截至目前，销巴生活已经与众多行业领军企业签约合作，可以为消费者提供成千上万种商品和服务，从茶米油盐，到吃穿住行，从一般生活服务，再到大宗商品交易，老百姓日常生活各个方面的消费需求都可以在销巴生活这一惠民养老服务平台上得到满足。</div>
					</div>
				</div>
			</van-col>
			<van-col span="24" class="xb-footer">
				招商电话：182-5812-3935<br>
				客服电话: 4000571671(转4)<br>
				浙江省杭州市江干区财富中心西楼3F
			</van-col>
			<van-col span="24" class="footer">
				<img src="../../assets/advDetail/commercialAgent/bottom.png" alt="">
			</van-col>
			
			
			
		</van-row>
	</div>
</template>
<script>
export default {
  data() {
    return {
    	isApp: true,
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  }
};
</script>
<style lang="less">
.commercialAgent {
	background: #C3FADE;
	min-height: 100%;
	position: relative;
	background: -webkit-linear-gradient(#4684E9, #06168E);
	/* Safari 5.1 - 6.0 */
	background: -o-linear-gradient(#4684E9, #06168E);
	/* Opera 11.1 - 12.0 */
	background: -moz-linear-gradient(#4684E9, #06168E);
	/* Firefox 3.6 - 15 */
	background: linear-gradient(#4684E9, #06168E);
	/* 标准的语法 */
	overflow: hidden;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.head_image {
		height: auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.benefit {
		margin-top: 2px;
		.odds {
			font-size: 30px;
			font-weight: 600;
			color: #fff;
			line-height: 30px;
			text-align: center;
			opacity: 0.3;
			background: linear-gradient(#fff, #4254D8);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
		.agent {
			display: flex;
			justify-content: center;
			margin-top: -8px;
			.agent_ {
				display: inline-block;
				font-size: 30px;
				font-family: PingFangSC-Semibold;
				font-weight: 600;
				color: #fff;
				text-align: center;
			}
			.circle {
				display: inline-block;
				width: 10px;
				height: 11px;
				border-radius: 50%;
				background: -webkit-linear-gradient(#3D74DC, #34D4F1);
				/* Safari 5.1 - 6.0 */
				background: -o-linear-gradient(#3D74DC, #34D4F1);
				/* Opera 11.1 - 12.0 */
				background: -moz-linear-gradient(#3D74DC, #34D4F1);
				/* Firefox 3.6 - 15 */
				background: linear-gradient(#3D74DC, #34D4F1);
				/* 标准的语法 */
			}
		}
		.benefit_3 {
			border-radius: 15px;
			background: rgba(242, 242, 242, .2);
			margin: 12px 10px 0 12px;
			overflow: hidden;
			.business {
				display: flex;
				margin-bottom: 31px;
				margin-top: 26px;
				.business-left {
					width: 61px;
					height: 62px;
					margin-left: 14px;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.business-right {
					padding-left: 14px;
					width: 66%;
					letter-spacing: 1px;
					.title {
						font-size: 20px;
						color: #fff;
						margin-bottom: 13px;
			
					}
					.enjoy {
						font-size: 14px;
						color: #fff;
						line-height: 21px;
					}
				}
				@media screen and (max-width:374px) {
					.business-right {
						width: 63%;
						padding-left: 10px;
					}
				}
			}
		}
	}
	.xb-main {
		margin-top: 2px;
		position: relative;
		.circle {
			margin-left: 12px;
			width: 65px;
			height: 63px;
			img {
				width: 100%;
				height: 100%;
			}
			@media only screen and (min-width: 320px) and (max-width: 360px){
				img{
					width: 75%;
					height: 75%;
				}
			}
		}
		@media screen and (max-width:374px) {
			.circle {
				margin-left: 20px;
			}
		}
		.circle_1 {
			position: absolute;
			top: 18px;
			right: 6px;
			width: 14px;
			height: 14px;
			border-radius: 50%;
			background: -webkit-linear-gradient(#3D74DC, #34D4F1);
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(#3D74DC, #34D4F1);
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(#3D74DC, #34D4F1);
			/* Firefox 3.6 - 15 */
			background: linear-gradient(#3D74DC, #34D4F1);
			/* 标准的语法 */
		}
		.xb-title {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			.xb-p1 {
				font-size: 30px;
				font-weight: 600;
				color: #fff;
				line-height: 30px;
				text-align: center;
				opacity: 0.3;
				background: linear-gradient(#fff, #4254D8);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				margin-top: 18px;
			}
			.xb-p2 {
				width: 215px;
				text-align: center;
				font-size: 30px;
				color: #fff;
				font-weight: 600;
				margin-top: -10px;
			}
		}
		.xb-items {
			margin: 31px 10px 0 12px;
			border-radius: 15px;
			padding: 30px 0;
			background: rgba(242, 242, 242, .2);
			p {
				text-align: center;
				font-size: 14px;
				color: #fff;
				width: 290px;
				margin: 0 auto;
				border-radius: 14px;
				line-height: 33px;
				margin-bottom: 11px;
				background: rgba(227, 235, 253, 0.13);
				letter-spacing: 1px;
			}
			p:last-child {
				margin-bottom: 0px;
			}
		}
	}
	.regular {
		margin-top: 2px;
		position: relative;
		.circle {
			width: 98px;
			height: 129px;
			padding-top: 45px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.xb-title {
			position: absolute;
		    width: 100%;
		    text-align: center;
			top: 6px;
			.xb-p1 {
				font-size: 30px;
				font-weight: 600;
				color: #fff;
				line-height: 30px;
				text-align: center;
				opacity: 0.3;
				background: linear-gradient(#fff, #4254D8);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				margin-top: 18px;
			}
			.xb-p3 {
				/*width: 247px;*/
				text-align: center;
				font-size: 30px;
				color: #fff;
				font-weight: 600;
				margin-top: -10px;
			}
		}
		.circle3 {
			position: absolute;
		    top: 25px;
    		right: 21px;
			width: 36px;
			height: 35px;
			border-radius: 50%;
			background: -webkit-linear-gradient(#3D74DC, #34D4F1);
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(#3D74DC, #34D4F1);
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(#3D74DC, #34D4F1);
			/* Firefox 3.6 - 15 */
			background: linear-gradient(#3D74DC, #34D4F1);
			/* 标准的语法 */
		}
		@media screen and (max-width:374px) {
			.circle3 {
				right: 25px;
			}
		}
		.regular-items {
			position: absolute;
			top: 94px;
			width: 100%;
			.regular_all {
				margin: 0 10px 0 12px;
				border-radius: 15px;
				background: rgba(242, 242, 242, .2);
				padding: 29px 18px 30px 14px;
				color: #fff;
				font-size: 14px;
				letter-spacing: 1px;
				line-height: 20px;
			}
		}
	}
	.cooperation {
		position: relative;
		margin-top: 201px;
		border-radius: 15px;
		background: rgba(242, 242, 242, .2);
		overflow: hidden;
		width: calc(100% - 22px);
		margin-left: 12px;
		h1 {
			font-size: 30px;
			font-weight: 600;
			line-height: 35px;
			color: #fff;
			text-align: center;
			margin-top: 26px;
			letter-spacing: 1px;
		}
		.introduction {
			margin-top: 15px;
			padding: 0 12px 0 18px;
			margin-bottom: 29px;
			img {
				width: 28px;
				height: 28px;
				vertical-align: middle;
			}
			.culture_1 {
				width: 31px;
				height: 25px;
			}
			.culture_2 {
				width: 24px;
				height: 33px;
			}
			span {
				font-size: 17px;
				margin-left: 18px;
				color: #fff;
				letter-spacing: 1px;
			}
			.content_1 {
				font-size: 14px;
				color: #fff;
				letter-spacing: 1px;
				margin-top: 17px;
				position: relative;
				line-height: 21px;
				.circle-r{
					width: 27px;
					height: 28px;
					border-radius: 50%;
					position: absolute;
					right: 89px;
					top: -28px;
					background: -webkit-linear-gradient(#3D74DC, #34D4F1);
					/* Safari 5.1 - 6.0 */
					background: -o-linear-gradient(#3D74DC, #34D4F1);
					/* Opera 11.1 - 12.0 */
					background: -moz-linear-gradient(#3D74DC, #34D4F1);
					/* Firefox 3.6 - 15 */
					background: linear-gradient(#3D74DC, #34D4F1);
					/* 标准的语法 */
		
				}
				@media only screen and (min-width: 320px) and (max-width: 360px){
					.circle-r {
						right: 63px;
					}
				}
			}
			.xb-top {
				width: 175px;
				font-size: 16px;
				line-height: 29px;
				background: -webkit-linear-gradient(left, #65C5FC, #466AF3);
				/* Safari 5.1 - 6.0 */
				background: -o-linear-gradient(right, #65C5FC, #466AF3);
				/* Opera 11.1 - 12.0 */
				background: -moz-linear-gradient(right, #65C5FC, #466AF3);
				/* Firefox 3.6 - 15 */
				background: linear-gradient(to right, #65C5FC, #466AF3);
				/* 标准的语法 */
				border-radius: 15px;
				text-align: center;
				color: #fff;
				margin-top: 20px;
			}
			.xb-center {
				margin-top: 10px;
				color: #fff;
				font-size: 14px;
				letter-spacing: 1px;
				line-height: 21px;
			}
		}
		.circle-right{
			width: 84px;
			height: 129px;
			position: absolute;
			top: 520px;
			right: 0;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	@media screen and (max-width:374px){
		.cooperation{
			margin-top: 220px;
			.circle-right{
				top: 580px;
			}
		}
	}
	.xb-footer {
		padding: 23px 0 29px 0;
		font-size: 14px;
		background: #fff;
		border-radius: 5px;
		color: #06168E;
		text-align: center;
		letter-spacing: 1px;
		line-height: 21px;
		width: calc(100% - 22px);
		margin: 14px 10px 0 12px;
		font-weight: 400;
		margin-bottom: 46px;
	}
	.footer {
		height: 104px;
		position: absolute;
		bottom: 0;
		img {
			width: 100%;
			height: 100%;
		}
	}
	
	
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
